import {lazy} from '@aboutyou/lazy-imports';

export const CouponWalletBodyContent = lazy(() =>
  import('./CouponWalletBodyContent.eager').then(mod => ({
    default: mod.CouponWalletBodyContent,
  })),
);
